import { AdminSubRole, Role } from '@ypp-portal/models/user/role';
import React from 'react';

interface AudienceCheckboxProps {
  label: string;
  role: Role | AdminSubRole;
  onChange: () => void;
}

const AudienceCheckbox: React.FC<AudienceCheckboxProps> = ({ role, label, onChange }) => {
  return (
    <div className='mb-2' key={role}>
      <input type='checkbox' id={role} onChange={onChange}></input>
      <label htmlFor={role} className='ml-1'>
        {label}
      </label>
    </div>
  );
};

export default AudienceCheckbox;
